import React from 'react'
import { LargeContent } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/NoFeesBanner/LargeContent'
import { MediumContent } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/NoFeesBanner/MediumContent'
import { SmallContent } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/NoFeesBanner/SmallContent'
import { NoFeesValues } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/config/NoFeesValues'

export const NoFeesBanner = ({ theatricalSlug, code }: { theatricalSlug: string; code: string }) => {
  const bannerValues = NoFeesValues[theatricalSlug]

  return (
    <div className="relative z-[39] mb-2 min-h-[120px] @container @[328px]:min-h-[160px] @[725px]:min-h-[140px]">
      <div className="min-h-[160px]: relative hidden @[725px]:block @[725px]:min-h-[140px]">
        <LargeContent code={code} bannerValues={bannerValues} />
      </div>
      <div className="relative hidden min-h-[160px] @[425px]:block @[725px]:hidden">
        <MediumContent code={code} bannerValues={bannerValues} />
      </div>
      <div className="relative min-h-[120px]  @[425px]:hidden">
        <SmallContent code={code} bannerValues={bannerValues} />
      </div>
    </div>
  )
}
